import { useState } from "react";
import { IconCheck, IconDeviceDesktop, IconMoon, IconSun } from "@tabler/icons-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useAuth } from "@/providers/auth-provider";
import { useTheme, type Theme } from "@/providers/theme-provider";

const THEME_OPTIONS: { value: Theme; label: string; icon: typeof IconSun }[] = [
  { value: "system", label: "System", icon: IconDeviceDesktop },
  { value: "light", label: "Light", icon: IconSun },
  { value: "dark", label: "Dark", icon: IconMoon },
];

export function AccountMenu({
  children,
  side,
  align,
}: {
  children: React.ReactNode;
  side: "top" | "bottom";
  align: "start" | "end";
}) {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const { theme, setTheme } = useTheme();

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent side={side} align={align} className="w-56 p-0">
        <div className="px-3 py-2.5 border-b border-border">
          <div className="text-[13px] font-medium truncate">{user.name}</div>
          <div className="text-[11px] text-muted-foreground truncate">{user.email}</div>
        </div>
        <div className="p-1">
          <div className="px-2 py-1 text-[10px] font-semibold text-muted-foreground uppercase tracking-[0.08em]">
            Appearance
          </div>
          {THEME_OPTIONS.map(({ value, label, icon: Icon }) => (
            <button
              key={value}
              onClick={() => {
                setTheme(value);
                setOpen(false);
              }}
              className="flex items-center gap-2 w-full px-2 py-1.5 text-[13px] font-medium rounded-sm
                hover:bg-accent hover:text-accent-foreground transition-colors"
            >
              <Icon className="h-4 w-4 text-muted-foreground" />
              {label}
              {theme === value && <IconCheck className="h-4 w-4 ml-auto text-muted-foreground" />}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
